/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type FreezeTransactionMutationVariables = {
    transferOrLedgerTransactionId: string;
    note?: string | null | undefined;
    currentUserMobile?: string | null | undefined;
    canReadHistory: boolean;
    canReadBalance: boolean;
    amount?: string | null | undefined;
};
export type FreezeTransactionMutationResponse = {
    readonly freezeTransaction: {
        readonly success: boolean;
        readonly user: {
            readonly primaryWallet: {
                readonly " $fragmentRefs": FragmentRefs<"PersonalTabHeader_wallet" | "History_wallet">;
            } | null;
        } | null;
    } | null;
};
export type FreezeTransactionMutation = {
    readonly response: FreezeTransactionMutationResponse;
    readonly variables: FreezeTransactionMutationVariables;
};



/*
mutation FreezeTransactionMutation(
  $transferOrLedgerTransactionId: ID!
  $note: String
  $currentUserMobile: String
  $canReadHistory: Boolean!
  $canReadBalance: Boolean!
  $amount: Decimal
) {
  freezeTransaction(transferOrLedgerTransactionId: $transferOrLedgerTransactionId, note: $note, currentUserMobile: $currentUserMobile, amount: $amount) {
    success
    user {
      primaryWallet {
        ...PersonalTabHeader_wallet_2fyIQr
        ...History_wallet_4E6zJv @include(if: $canReadHistory)
        id
      }
      id
    }
  }
}

fragment AdjustmentEntry_tx on AdjustmentEntry {
  __typename
  description
  senderMobile
  recipientMobile
  ...HistoryEntry_entry
}

fragment AgentDepositsBlockHistory_user on User {
  id
  historyOfAgentDepositsUnblocks {
    whenBlocked
    whenUnblocked
    blockedBy
    blockReason
    blockSubject
    unblockReason
    unblockedBy
  }
}

fragment AllowToRecoverPin_user on User {
  id
  inPinRecovery
  isPinResetRisky
  customerAppVersion {
    appType
    string
    isUpToDate
    appVersionCode
  }
}

fragment BillPaymentEntry_tx on BillPaymentEntry {
  transferId
  senderMobile
  maybeTerminatedSenderMobile
  relatedTicket {
    status
    slackMessageUrl
  }
  scamReports {
    whenOpened
    whenResolved
    status
    transactionIds
  }
  billPayProblems {
    whenOpened
    billType
    status
    transactionId
  }
  amount
  billAccount
  billId
  billName
  isCancelled
  summary
  errorCode
  localizedErrMessage
  airtimeSms
  meterNumber
  ...HistoryEntry_entry
}

fragment BlockFromAgentDeposits_user on User {
  id
  agentDepositsBlock {
    whenBlocked
    blockedBy
    blockReason
    id
  }
  ...AgentDepositsBlockHistory_user
}

fragment BlockRecipient_transfer on MobileTransferEntry {
  __isMobileTransferEntry: __typename
  id
  transferId
  recipientName
  recipientMobile
}

fragment BlockUnblockUser_wallet on Wallet {
  id
  mobile
  activeMobileBlock {
    id
    blockReason
    blockedBy
    whenBlocked
    blockSubject
  }
  activeLegalEntityBlock {
    id
    blockReason
    blockedBy
    whenBlocked
    blockSubject
  }
  blockHistory {
    whenBlocked
    blockedBy
    blockReason
    whenUnblocked
    unblockedBy
    unblockReason
    blockSubject
  }
}

fragment CancelAllAtx_wallet on Wallet {
  name
  mobile
}

fragment ChangePayoutRecipient_transfer on PayoutTransferEntry {
  tcid
  amount
  senderOpaqueId
  sender: senderName
  maybeRecipientName: recipientName
  recipientMobile
  isReversal
}

fragment ChangeRecipient_transfer on MobileTransferEntry {
  __isMobileTransferEntry: __typename
  id
  transferId
  amount
  receiveAmount
  recipientMobile
  recipientName
}

fragment ChangeRemittanceRecipient_transfer on RemittanceTransferReceivedEntry {
  opaqueId
  senderName
  senderMobile
  amount
}

fragment ClearPinRateLimitAction_user on User {
  devices {
    hasPinRateLimitBlock
  }
  ...ClearPinRateLimit_user
}

fragment ClearPinRateLimit_user on User {
  id
  devices {
    deviceId
    deviceModel
    deviceName
    hasPinRateLimitBlock
  }
}

fragment DirectDepositBlockHistory_user on User {
  id
  narrativeDirectDepositBlockHistory {
    whatHappened
    whenHappened
    doneBy
    reason
  }
}

fragment EscalateToMerchantSupport_user on User {
  possibleMerchantIssueTypes {
    type
    displayName
  }
  merchant {
    ufid
    id
  }
}

fragment FailedMerchantTransferEntry_tx on FailedMerchantTransferEntry {
  id
  whenEntered
  sendAmount
  receiveAmount
  isCancelled
  merchantId
  merchantName
  scamInvestigationFields {
    deviceId
    deviceModel
    deviceName
    userInterface
  }
}

fragment ForgetQr_user on User {
  id
  name
  needsNewPin
  primaryWallet {
    name
    id
  }
}

fragment HistoryEntry_entry on HistoryEntry {
  __isHistoryEntry: __typename
  id
  whenEntered
  amount
  balance
  summary
  isPending
  isCancelled
  ... on SupportHistoryEntry {
    __isSupportHistoryEntry: __typename
    scamInvestigationFields {
      deviceId
      deviceModel
      deviceName
      userInterface
      agentMobile
    }
  }
  ... on AgentTransactionEntry {
    agentTransactionId
  }
  ... on TransferSentEntry {
    transferId
  }
}

fragment History_wallet_4E6zJv on Wallet {
  mobile
  cell: mobile
  user {
    devices {
      deviceId
      activeBlock {
        blockReason
        id
      }
    }
    id
  }
  supportHistoryConnection(last: 10) {
    edges {
      cursor
      node {
        __typename
        id
        scamInvestigationFields {
          deviceId
          deviceModel
          userInterface
        }
        ... on TransferSentEntry {
          transferId
          isPending
          isCancelled
        }
        ... on TransferReceivedEntry {
          transferId
          isPending
          isCancelled
        }
        ... on AgentTransactionEntry {
          agentTransactionId
          isPending
          isCancelled
        }
        ... on BillPaymentEntry {
          transferId
          isPending
          isCancelled
        }
        ... on PayoutTransferEntry {
          tcid
          isPending
          isCancelled
          amount
        }
        ...PersonalHistoryEntry_entry
        ... on HistoryEntry {
          __isHistoryEntry: __typename
          whenEntered
          isPending
          isCancelled
        }
        ... on TransferReceivedReversalEntry {
          reversedTransferId: transferId
          isPending
          isCancelled
        }
        ... on TransferSentReversalEntry {
          reversedTransferId: transferId
          isPending
          isCancelled
        }
        ... on PurchaseEntry {
          transferId
          isPending
          isCancelled
        }
        ... on RemittanceTransferReversalEntry {
          opaqueId
          isPending
          isCancelled
        }
        ... on FailedMerchantTransferEntry {
          sendAmount
          receiveAmount
          isCancelled
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}

fragment LoginLogoutEvent_tx on LoginLogoutEvent {
  id
  event
  whenEntered
  correspondingLoginTime
  scamInvestigationFields {
    deviceId
    deviceModel
    deviceName
  }
}

fragment LogoutAllUserSessions_user on User {
  id
}

fragment PaymentCardTransferEntry_tx on PaymentCardTransferEntry {
  amount
  summary
  description
  transferId
  mobile
  baseReceiptFields {
    formatType
    label
    value
  }
  ...HistoryEntry_entry
}

fragment PayoutTransferEntry_tx on PayoutTransferEntry {
  tcid
  amount
  senderOpaqueId
  senderName
  recipientMobile
  isReversal
  ...HistoryEntry_entry
  ...SupportPayoutTransferReverse_transfer
  ...ChangePayoutRecipient_transfer
}

fragment PersonalHistoryEntry_entry on SupportHistoryEntry {
  __isSupportHistoryEntry: __typename
  __typename
  ...HistoryEntry_entry
  ...UserAtxEntry_tx
  ...BillPaymentEntry_tx
  ...UserLinkedAccountTransferB2WEntry_tx
  ...UserLinkedAccountTransferW2BEntry_tx
  ...PaymentCardTransferEntry_tx
  ...TransferReceivedEntry_tx
  ...TransferSentEntry_tx
  ...TransferSentReversalEntry_tx
  ...TransferReceivedReversalEntry_tx
  ...PayoutTransferEntry_tx
  ...PurchaseEntry_tx
  ...RemittanceTransferReceivedEntry_tx
  ...RemittanceTransferReversalEntry_tx
  ...AdjustmentEntry_tx
  ...LoginLogoutEvent_tx
  ...FailedMerchantTransferEntry_tx
  ...ReversalDisputeEntry_tx
}

fragment PersonalTabHeader_wallet_2fyIQr on Wallet {
  id
  mobile
  name
  balance @include(if: $canReadBalance)
  amountPending @include(if: $canReadBalance)
  kycTier
  kybTier
  isTrader
  photoEditUrl
  documentStatus
  hasRejectedGovIds
  isRefundAbuser
  whenTerminated
  reasonTerminated
  whoTerminated
  tickets {
    whenOpened
    whenResolved
    status
    slackMessageUrl
    ticketType
    reference
  }
  activeMobileBlock {
    whenBlocked
    blockSubject
    requestToModifyBlockTickets {
      status
    }
    id
  }
  activeLegalEntityBlock {
    whenBlocked
    blockSubject
    requestToModifyBlockTickets {
      status
    }
    id
  }
  scamReports {
    whenOpened
    whenResolved
    status
    transactionIds
  }
  billPayProblems {
    whenOpened
    billType
    status
    transactionId
  }
  supportGroupLeadEscalations {
    whenOpened
    status
    clickupTaskId
  }
  supportPartialRefundEscalations {
    whenOpened
    status
    clickupTaskId
  }
  merchantSupportEscalations {
    whenOpened
    status
    clickupTaskId
  }
  balanceLimitInfoV1 {
    max
  }
  inflowLimitInfoV1 {
    max
  }
  ...ShowWithdrawalCodes_wallet
  ...ShowWoyofalCodes_wallet
  ...ResetPin_wallet
  ...SendUpdateAppLink_wallet
  ...SendWithdrawalCode_wallet
  ...SendWoyofalCode_wallet
  ...RenameWallet_wallet
  ...CancelAllAtx_wallet
  ...RequestToBlockUnblockUser_wallet
  ...RequestToUnblockFromAgentDeposits_wallet
  ...RequestToUnblockFromUsingMultipleDevices_wallet
  ...BlockUnblockUser_wallet
  user {
    isPinResetRisky
    devices {
      deviceId
      deviceModel
      whenLoggedOut
      failedLoginDevice
      activeBlock {
        blockReason
        id
      }
    }
    customerAppVersion {
      appType
      string
      isUpToDate
    }
    hasQrCard
    customerOverdraftStatus
    qrCardBlock {
      whenBlocked
      id
    }
    personalMultipleDevicesBlock {
      whenBlocked
      id
    }
    agentMultipleDevicesBlock {
      whenBlocked
      id
    }
    agentDepositsBlock {
      whenBlocked
      id
    }
    needsIdPhotoConfirmation {
      legalName
    }
    userOnAgentGamingWatchlist {
      isOnList
      whenUpdated
    }
    userOnAgentGamingWhitelist {
      isOnList
      whenUpdated
    }
    inPinRecovery
    hasWeakPin
    elligibleToReceivePayPromo
    ...AllowToRecoverPin_user
    ...UnblockFromUsingQrCards_user
    ...UnblockFromUsingMultipleDevices_user
    ...BlockFromAgentDeposits_user
    ...UnblockFromAgentDeposits_user
    ...LogoutAllUserSessions_user
    ...ForgetQr_user
    ...EscalateToMerchantSupport_user
    ...ClearPinRateLimitAction_user
    id
  }
  legalEntity {
    wallets(walletType: PERSONAL) {
      mobile
      id
    }
  }
}

fragment PurchaseEntry_tx on PurchaseEntry {
  senderMobile
  maybeTerminatedSenderMobile
  amount
  merchantId
  merchantName
  merchantCode
  merchantMobile
  promoUsed
  transferId
  isRefunded
  isRemote
  relatedTicket {
    whenOpened
    whenResolved
    status
    slackMessageUrl
    ticketType
    reference
  }
  scamReports {
    whenOpened
    whenResolved
    status
    transactionIds
  }
  ...HistoryEntry_entry
  ...RefundPurchaseEntry_transfer
}

fragment RefundP2P_transfer on MobileTransferEntry {
  __isMobileTransferEntry: __typename
  id
  transferId
  sendAmount
  receiveAmount
  senderName
  senderMobile
  recipientName
  maybeTerminatedRecipientMobile
}

fragment RefundPurchaseEntry_transfer on PurchaseEntry {
  id
  transferId
  amount
  merchantName
}

fragment RemittanceTransferReceivedEntry_tx on RemittanceTransferReceivedEntry {
  id
  opaqueId
  description
  amount
  isPending
  isCancelled
  senderName
  senderMobile
  senderCountry
  recipientMobile
  receiveAmount
  ...HistoryEntry_entry
  ...RemittanceTransferRefund_transfer
  ...ChangeRemittanceRecipient_transfer
}

fragment RemittanceTransferRefund_transfer on RemittanceTransferReceivedEntry {
  opaqueId
  senderName
  senderMobile
  amount
}

fragment RemittanceTransferReversalEntry_tx on RemittanceTransferReversalEntry {
  id
  opaqueId
  description
  amount
  isPending
  senderName
  senderMobile
  senderCountry
  recipientMobile
  receiveAmount
  ...HistoryEntry_entry
}

fragment RenameWallet_wallet on Wallet {
  id
  name
  mobile
  user {
    name
    id
  }
}

fragment RequestToBlockUnblockUser_wallet on Wallet {
  id
  mobile
  activeMobileBlock {
    whenBlocked
    id
  }
  activeLegalEntityBlock {
    whenBlocked
    id
  }
  blockHistory {
    whenBlocked
    blockedBy
    blockReason
    whenUnblocked
    unblockedBy
    unblockReason
    blockSubject
  }
  tickets {
    whenOpened
    whenResolved
    status
    slackMessageUrl
    ticketType
    reference
  }
}

fragment RequestToUnblockFromAgentDeposits_wallet on Wallet {
  id
  mobile
  activeMobileBlock {
    whenBlocked
    id
  }
  activeLegalEntityBlock {
    whenBlocked
    id
  }
  blockHistory {
    whenBlocked
    blockedBy
    blockReason
    whenUnblocked
    unblockedBy
    unblockReason
    blockSubject
  }
  tickets {
    whenOpened
    whenResolved
    status
    slackMessageUrl
    ticketType
    reference
  }
}

fragment RequestToUnblockFromUsingMultipleDevices_wallet on Wallet {
  id
  mobile
  activeMobileBlock {
    whenBlocked
    id
  }
  activeLegalEntityBlock {
    whenBlocked
    id
  }
  blockHistory {
    whenBlocked
    blockedBy
    blockReason
    whenUnblocked
    unblockedBy
    unblockReason
    blockSubject
  }
  tickets {
    whenOpened
    whenResolved
    status
    slackMessageUrl
    ticketType
    reference
  }
}

fragment ResetPin_wallet on Wallet {
  name
  user {
    id
    isPinResetRisky
  }
}

fragment ReversalDisputeEntry_tx on ReversalDisputeEntry {
  __typename
  description
  isPending
  ledgerTransactionId
  originalTransferId
  ...HistoryEntry_entry
}

fragment SendUpdateAppLink_wallet on Wallet {
  mobile
  name
  id
}

fragment SendWithdrawalCode_wallet on Wallet {
  id
  mobile
  name
}

fragment SendWoyofalCode_wallet on Wallet {
  id
  mobile
  name
}

fragment ShowWithdrawalCodes_wallet on Wallet {
  id
  name
  mobile
  ...SendWithdrawalCode_wallet
}

fragment ShowWoyofalCodes_wallet on Wallet {
  id
  name
  mobile
  ...SendWoyofalCode_wallet
}

fragment SupportPayoutTransferReverse_transfer on PayoutTransferEntry {
  tcid
  amount
  senderOpaqueId
  sender: senderName
  maybeRecipientName: recipientName
  recipientMobile
  isReversal
}

fragment TransferReceivedEntry_tx on TransferReceivedEntry {
  transferId
  senderName
  senderMobile
  maybeTerminatedSenderMobile
  paymentBatchId
  recipientMobile
  receiveAmount
  ...HistoryEntry_entry
  ...ChangeRecipient_transfer
  ...RefundP2P_transfer
}

fragment TransferReceivedReversalEntry_tx on TransferReceivedReversalEntry {
  transferId
  description
  isPending
  isFreezingFunds
  ledgerTransactionId
  senderMobile
  sendAmount
  recipientMobile
  ...HistoryEntry_entry
}

fragment TransferSentEntry_tx on TransferSentEntry {
  transferId
  senderMobile
  recipientName
  recipientMobile
  maybeTerminatedRecipientMobile
  amount
  receiveAmount
  relatedTicket {
    whenOpened
    whenResolved
    status
    slackMessageUrl
    ticketType
    reference
  }
  scamReports {
    whenOpened
    whenResolved
    status
    transactionIds
  }
  ...ChangeRecipient_transfer
  ...RefundP2P_transfer
  ...BlockRecipient_transfer
  ...HistoryEntry_entry
}

fragment TransferSentReversalEntry_tx on TransferSentReversalEntry {
  transferId
  description
  isPending
  isFreezingFunds
  ledgerTransactionId
  senderMobile
  sendAmount
  ...HistoryEntry_entry
}

fragment UnblockFromAgentDeposits_user on User {
  id
  agentDepositsBlock {
    whenBlocked
    blockedBy
    blockReason
    id
  }
  ...AgentDepositsBlockHistory_user
}

fragment UnblockFromUsingMultipleDevices_user on User {
  id
  personalMultipleDevicesBlock {
    blockReason
    blockedBy
    whenBlocked
    whenExpires
    lockedDevice {
      deviceId
      deviceName
      deviceModel
    }
    id
  }
  agentMultipleDevicesBlock {
    blockReason
    blockedBy
    whenBlocked
    whenExpires
    lockedDevice {
      deviceId
      deviceName
      deviceModel
    }
    id
  }
  ...DirectDepositBlockHistory_user
}

fragment UnblockFromUsingQrCards_user on User {
  ...DirectDepositBlockHistory_user
  id
  qrCardBlock {
    whenBlocked
    blockedBy
    blockReason
    whenExpires
    id
  }
}

fragment UserAtxEntry_tx on AgentTransactionEntry {
  agentTransactionId
  isDeposit
  agentName
  agentId
  agentUfid
  customerMobile
  customerName
  maybeTerminatedCustomerMobile
  amount
  relatedTicket {
    whenOpened
    whenResolved
    status
    slackMessageUrl
    ticketType
    reference
  }
  scamReports {
    whenOpened
    whenResolved
    status
    transactionIds
  }
  ...HistoryEntry_entry
}

fragment UserLinkedAccountTransferB2WEntry_tx on UserLinkedAccountTransferB2WEntry {
  summary
  isCancelled
  partnerName
  liaTransferId
  errorCode
  errorMessage
  ...HistoryEntry_entry
}

fragment UserLinkedAccountTransferW2BEntry_tx on UserLinkedAccountTransferW2BEntry {
  summary
  isCancelled
  partnerName
  liaTransferId
  errorCode
  errorMessage
  ...HistoryEntry_entry
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "amount"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "canReadBalance"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "canReadHistory"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currentUserMobile"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "note"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "transferOrLedgerTransactionId"
},
v6 = [
  {
    "kind": "Variable",
    "name": "amount",
    "variableName": "amount"
  },
  {
    "kind": "Variable",
    "name": "currentUserMobile",
    "variableName": "currentUserMobile"
  },
  {
    "kind": "Variable",
    "name": "note",
    "variableName": "note"
  },
  {
    "kind": "Variable",
    "name": "transferOrLedgerTransactionId",
    "variableName": "transferOrLedgerTransactionId"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v8 = [
  {
    "kind": "Literal",
    "name": "last",
    "value": 10
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mobile",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenOpened",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenResolved",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slackMessageUrl",
  "storageKey": null
},
v16 = [
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "ticketType",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "reference",
    "storageKey": null
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenBlocked",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blockSubject",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blockReason",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blockedBy",
  "storageKey": null
},
v21 = [
  (v17/*: any*/),
  (v18/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "TicketShortInfo",
    "kind": "LinkedField",
    "name": "requestToModifyBlockTickets",
    "plural": true,
    "selections": [
      (v14/*: any*/)
    ],
    "storageKey": null
  },
  (v9/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/)
],
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "ScamReportTicket",
  "kind": "LinkedField",
  "name": "scamReports",
  "plural": true,
  "selections": [
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transactionIds",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "BillPayProblemTicket",
  "kind": "LinkedField",
  "name": "billPayProblems",
  "plural": true,
  "selections": [
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billType",
      "storageKey": null
    },
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transactionId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = [
  (v12/*: any*/),
  (v14/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "clickupTaskId",
    "storageKey": null
  }
],
v25 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "max",
    "storageKey": null
  }
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deviceId",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deviceModel",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deviceName",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenExpires",
  "storageKey": null
},
v30 = [
  (v17/*: any*/),
  (v9/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/),
  (v29/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "UserDevice",
    "kind": "LinkedField",
    "name": "lockedDevice",
    "plural": false,
    "selections": [
      (v26/*: any*/),
      (v28/*: any*/),
      (v27/*: any*/)
    ],
    "storageKey": null
  }
],
v31 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isOnList",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "whenUpdated",
    "storageKey": null
  }
],
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenUnblocked",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unblockReason",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unblockedBy",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "balance",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transferId",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPending",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCancelled",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "senderMobile",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recipientName",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recipientMobile",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maybeTerminatedRecipientMobile",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "receiveAmount",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "TicketShortInfo",
  "kind": "LinkedField",
  "name": "relatedTicket",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sendAmount",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "senderName",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenEntered",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v50 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ScamInvestigationFields",
      "kind": "LinkedField",
      "name": "scamInvestigationFields",
      "plural": false,
      "selections": [
        (v28/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "agentMobile",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SupportHistoryEntry",
  "abstractKey": "__isSupportHistoryEntry"
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "agentTransactionId",
  "storageKey": null
},
v52 = {
  "kind": "InlineFragment",
  "selections": [
    (v51/*: any*/)
  ],
  "type": "AgentTransactionEntry",
  "abstractKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maybeTerminatedSenderMobile",
  "storageKey": null
},
v54 = {
  "kind": "InlineFragment",
  "selections": [
    (v48/*: any*/),
    (v35/*: any*/),
    (v49/*: any*/),
    (v50/*: any*/)
  ],
  "type": "HistoryEntry",
  "abstractKey": "__isHistoryEntry"
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorCode",
  "storageKey": null
},
v56 = [
  (v49/*: any*/),
  (v38/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "partnerName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "liaTransferId",
    "storageKey": null
  },
  (v55/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "errorMessage",
    "storageKey": null
  }
],
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFreezingFunds",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ledgerTransactionId",
  "storageKey": null
},
v60 = {
  "alias": "reversedTransferId",
  "args": null,
  "kind": "ScalarField",
  "name": "transferId",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "merchantId",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "merchantName",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "opaqueId",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "senderCountry",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "concreteType": "ScamInvestigationFields",
  "kind": "LinkedField",
  "name": "scamInvestigationFields",
  "plural": false,
  "selections": [
    (v28/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "FreezeTransactionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "FreezeTransaction",
        "kind": "LinkedField",
        "name": "freezeTransaction",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Wallet",
                "kind": "LinkedField",
                "name": "primaryWallet",
                "plural": false,
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "canReadBalance",
                        "variableName": "canReadBalance"
                      }
                    ],
                    "kind": "FragmentSpread",
                    "name": "PersonalTabHeader_wallet"
                  },
                  {
                    "condition": "canReadHistory",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": (v8/*: any*/),
                        "kind": "FragmentSpread",
                        "name": "History_wallet"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "FreezeTransactionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "FreezeTransaction",
        "kind": "LinkedField",
        "name": "freezeTransaction",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Wallet",
                "kind": "LinkedField",
                "name": "primaryWallet",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "kycTier",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "kybTier",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isTrader",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "photoEditUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "documentStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasRejectedGovIds",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isRefundAbuser",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "whenTerminated",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reasonTerminated",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "whoTerminated",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TicketShortInfo",
                    "kind": "LinkedField",
                    "name": "tickets",
                    "plural": true,
                    "selections": (v16/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ActiveBlock",
                    "kind": "LinkedField",
                    "name": "activeMobileBlock",
                    "plural": false,
                    "selections": (v21/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ActiveBlock",
                    "kind": "LinkedField",
                    "name": "activeLegalEntityBlock",
                    "plural": false,
                    "selections": (v21/*: any*/),
                    "storageKey": null
                  },
                  (v22/*: any*/),
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SupportGroupLeadEscalationTicket",
                    "kind": "LinkedField",
                    "name": "supportGroupLeadEscalations",
                    "plural": true,
                    "selections": (v24/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RefundPartialFundsTicket",
                    "kind": "LinkedField",
                    "name": "supportPartialRefundEscalations",
                    "plural": true,
                    "selections": (v24/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MerchantSupportEscalationTicket",
                    "kind": "LinkedField",
                    "name": "merchantSupportEscalations",
                    "plural": true,
                    "selections": (v24/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LimitInfo",
                    "kind": "LinkedField",
                    "name": "balanceLimitInfoV1",
                    "plural": false,
                    "selections": (v25/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LimitInfo",
                    "kind": "LinkedField",
                    "name": "inflowLimitInfoV1",
                    "plural": false,
                    "selections": (v25/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isPinResetRisky",
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserDevice",
                        "kind": "LinkedField",
                        "name": "devices",
                        "plural": true,
                        "selections": [
                          (v26/*: any*/),
                          (v27/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "whenLoggedOut",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "failedLoginDevice",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ActiveBlock",
                            "kind": "LinkedField",
                            "name": "activeBlock",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasPinRateLimitBlock",
                            "storageKey": null
                          },
                          (v28/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AppVersion",
                        "kind": "LinkedField",
                        "name": "customerAppVersion",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "appType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "string",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isUpToDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "appVersionCode",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasQrCard",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "customerOverdraftStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ActiveBlock",
                        "kind": "LinkedField",
                        "name": "qrCardBlock",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v9/*: any*/),
                          (v20/*: any*/),
                          (v19/*: any*/),
                          (v29/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MultipleDevicesBlock",
                        "kind": "LinkedField",
                        "name": "personalMultipleDevicesBlock",
                        "plural": false,
                        "selections": (v30/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MultipleDevicesBlock",
                        "kind": "LinkedField",
                        "name": "agentMultipleDevicesBlock",
                        "plural": false,
                        "selections": (v30/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ActiveBlock",
                        "kind": "LinkedField",
                        "name": "agentDepositsBlock",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v9/*: any*/),
                          (v20/*: any*/),
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IdDocument",
                        "kind": "LinkedField",
                        "name": "needsIdPhotoConfirmation",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "legalName",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgentGamingListEntry",
                        "kind": "LinkedField",
                        "name": "userOnAgentGamingWatchlist",
                        "plural": false,
                        "selections": (v31/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgentGamingListEntry",
                        "kind": "LinkedField",
                        "name": "userOnAgentGamingWhitelist",
                        "plural": false,
                        "selections": (v31/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "inPinRecovery",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasWeakPin",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "elligibleToReceivePayPromo",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BlockHistoryEntry",
                        "kind": "LinkedField",
                        "name": "narrativeDirectDepositBlockHistory",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "whatHappened",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "whenHappened",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "doneBy",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "reason",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Block",
                        "kind": "LinkedField",
                        "name": "historyOfAgentDepositsUnblocks",
                        "plural": true,
                        "selections": [
                          (v17/*: any*/),
                          (v32/*: any*/),
                          (v20/*: any*/),
                          (v19/*: any*/),
                          (v18/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "needsNewPin",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Wallet",
                        "kind": "LinkedField",
                        "name": "primaryWallet",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MerchantIssueEntry",
                        "kind": "LinkedField",
                        "name": "possibleMerchantIssueTypes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayName",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Merchant",
                        "kind": "LinkedField",
                        "name": "merchant",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ufid",
                            "storageKey": null
                          },
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Block",
                    "kind": "LinkedField",
                    "name": "blockHistory",
                    "plural": true,
                    "selections": [
                      (v17/*: any*/),
                      (v20/*: any*/),
                      (v19/*: any*/),
                      (v32/*: any*/),
                      (v34/*: any*/),
                      (v33/*: any*/),
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LegalEntity",
                    "kind": "LinkedField",
                    "name": "legalEntity",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "walletType",
                            "value": "PERSONAL"
                          }
                        ],
                        "concreteType": "Wallet",
                        "kind": "LinkedField",
                        "name": "wallets",
                        "plural": true,
                        "selections": [
                          (v10/*: any*/),
                          (v9/*: any*/)
                        ],
                        "storageKey": "wallets(walletType:\"PERSONAL\")"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "condition": "canReadBalance",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v35/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "amountPending",
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "canReadHistory",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": "cell",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "mobile",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v8/*: any*/),
                        "concreteType": "SupportHistoryConnection",
                        "kind": "LinkedField",
                        "name": "supportHistoryConnection",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SupportHistoryEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cursor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "__typename",
                                    "storageKey": null
                                  },
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScamInvestigationFields",
                                    "kind": "LinkedField",
                                    "name": "scamInvestigationFields",
                                    "plural": false,
                                    "selections": [
                                      (v26/*: any*/),
                                      (v27/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "userInterface",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isSupportHistoryEntry"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v36/*: any*/),
                                      (v37/*: any*/),
                                      (v38/*: any*/),
                                      (v39/*: any*/),
                                      (v40/*: any*/),
                                      (v41/*: any*/),
                                      (v42/*: any*/),
                                      (v43/*: any*/),
                                      (v44/*: any*/),
                                      (v45/*: any*/),
                                      (v22/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v46/*: any*/),
                                          (v47/*: any*/)
                                        ],
                                        "type": "MobileTransferEntry",
                                        "abstractKey": "__isMobileTransferEntry"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v48/*: any*/),
                                          (v35/*: any*/),
                                          (v49/*: any*/),
                                          (v50/*: any*/),
                                          (v52/*: any*/)
                                        ],
                                        "type": "HistoryEntry",
                                        "abstractKey": "__isHistoryEntry"
                                      }
                                    ],
                                    "type": "TransferSentEntry",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v36/*: any*/),
                                      (v37/*: any*/),
                                      (v38/*: any*/),
                                      (v47/*: any*/),
                                      (v39/*: any*/),
                                      (v53/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "paymentBatchId",
                                        "storageKey": null
                                      },
                                      (v41/*: any*/),
                                      (v44/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v48/*: any*/),
                                          (v43/*: any*/),
                                          (v35/*: any*/),
                                          (v49/*: any*/),
                                          (v50/*: any*/),
                                          (v52/*: any*/)
                                        ],
                                        "type": "HistoryEntry",
                                        "abstractKey": "__isHistoryEntry"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v43/*: any*/),
                                          (v40/*: any*/),
                                          (v46/*: any*/),
                                          (v42/*: any*/)
                                        ],
                                        "type": "MobileTransferEntry",
                                        "abstractKey": "__isMobileTransferEntry"
                                      }
                                    ],
                                    "type": "TransferReceivedEntry",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v51/*: any*/),
                                      (v37/*: any*/),
                                      (v38/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isDeposit",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "agentName",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "agentId",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "agentUfid",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "customerMobile",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "customerName",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "maybeTerminatedCustomerMobile",
                                        "storageKey": null
                                      },
                                      (v43/*: any*/),
                                      (v45/*: any*/),
                                      (v22/*: any*/),
                                      (v54/*: any*/)
                                    ],
                                    "type": "AgentTransactionEntry",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v36/*: any*/),
                                      (v37/*: any*/),
                                      (v38/*: any*/),
                                      (v39/*: any*/),
                                      (v53/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TicketShortInfo",
                                        "kind": "LinkedField",
                                        "name": "relatedTicket",
                                        "plural": false,
                                        "selections": [
                                          (v14/*: any*/),
                                          (v15/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v22/*: any*/),
                                      (v23/*: any*/),
                                      (v43/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "billAccount",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "billId",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "billName",
                                        "storageKey": null
                                      },
                                      (v49/*: any*/),
                                      (v55/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "localizedErrMessage",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "airtimeSms",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "meterNumber",
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v48/*: any*/),
                                          (v35/*: any*/),
                                          (v50/*: any*/)
                                        ],
                                        "type": "HistoryEntry",
                                        "abstractKey": "__isHistoryEntry"
                                      }
                                    ],
                                    "type": "BillPaymentEntry",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "tcid",
                                        "storageKey": null
                                      },
                                      (v37/*: any*/),
                                      (v38/*: any*/),
                                      (v43/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "senderOpaqueId",
                                        "storageKey": null
                                      },
                                      (v47/*: any*/),
                                      (v41/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isReversal",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": "sender",
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "senderName",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": "maybeRecipientName",
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "recipientName",
                                        "storageKey": null
                                      },
                                      (v54/*: any*/)
                                    ],
                                    "type": "PayoutTransferEntry",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v48/*: any*/),
                                      (v43/*: any*/),
                                      (v35/*: any*/),
                                      (v49/*: any*/),
                                      (v37/*: any*/),
                                      (v38/*: any*/),
                                      (v50/*: any*/)
                                    ],
                                    "type": "HistoryEntry",
                                    "abstractKey": "__isHistoryEntry"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v56/*: any*/),
                                    "type": "UserLinkedAccountTransferB2WEntry",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v56/*: any*/),
                                    "type": "UserLinkedAccountTransferW2BEntry",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v43/*: any*/),
                                      (v49/*: any*/),
                                      (v57/*: any*/),
                                      (v36/*: any*/),
                                      (v10/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ReceiptField",
                                        "kind": "LinkedField",
                                        "name": "baseReceiptFields",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "formatType",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "label",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "value",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "PaymentCardTransferEntry",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v36/*: any*/),
                                      (v57/*: any*/),
                                      (v37/*: any*/),
                                      (v58/*: any*/),
                                      (v59/*: any*/),
                                      (v39/*: any*/),
                                      (v46/*: any*/),
                                      (v60/*: any*/),
                                      (v38/*: any*/)
                                    ],
                                    "type": "TransferSentReversalEntry",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v36/*: any*/),
                                      (v57/*: any*/),
                                      (v37/*: any*/),
                                      (v58/*: any*/),
                                      (v59/*: any*/),
                                      (v39/*: any*/),
                                      (v46/*: any*/),
                                      (v41/*: any*/),
                                      (v60/*: any*/),
                                      (v38/*: any*/)
                                    ],
                                    "type": "TransferReceivedReversalEntry",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v39/*: any*/),
                                      (v53/*: any*/),
                                      (v43/*: any*/),
                                      (v61/*: any*/),
                                      (v62/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "merchantCode",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "merchantMobile",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "promoUsed",
                                        "storageKey": null
                                      },
                                      (v36/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isRefunded",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isRemote",
                                        "storageKey": null
                                      },
                                      (v45/*: any*/),
                                      (v22/*: any*/),
                                      (v37/*: any*/),
                                      (v38/*: any*/)
                                    ],
                                    "type": "PurchaseEntry",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v63/*: any*/),
                                      (v57/*: any*/),
                                      (v43/*: any*/),
                                      (v37/*: any*/),
                                      (v38/*: any*/),
                                      (v47/*: any*/),
                                      (v39/*: any*/),
                                      (v64/*: any*/),
                                      (v41/*: any*/),
                                      (v44/*: any*/)
                                    ],
                                    "type": "RemittanceTransferReceivedEntry",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v63/*: any*/),
                                      (v57/*: any*/),
                                      (v43/*: any*/),
                                      (v37/*: any*/),
                                      (v47/*: any*/),
                                      (v39/*: any*/),
                                      (v64/*: any*/),
                                      (v41/*: any*/),
                                      (v44/*: any*/),
                                      (v38/*: any*/)
                                    ],
                                    "type": "RemittanceTransferReversalEntry",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v57/*: any*/),
                                      (v39/*: any*/),
                                      (v41/*: any*/)
                                    ],
                                    "type": "AdjustmentEntry",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "event",
                                        "storageKey": null
                                      },
                                      (v48/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "correspondingLoginTime",
                                        "storageKey": null
                                      },
                                      (v65/*: any*/)
                                    ],
                                    "type": "LoginLogoutEvent",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v48/*: any*/),
                                      (v46/*: any*/),
                                      (v44/*: any*/),
                                      (v38/*: any*/),
                                      (v61/*: any*/),
                                      (v62/*: any*/),
                                      (v65/*: any*/)
                                    ],
                                    "type": "FailedMerchantTransferEntry",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v57/*: any*/),
                                      (v37/*: any*/),
                                      (v59/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "originalTransferId",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "ReversalDisputeEntry",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasNextPage",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasPreviousPage",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "startCursor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endCursor",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "supportHistoryConnection(last:10)"
                      },
                      {
                        "alias": null,
                        "args": (v8/*: any*/),
                        "filters": [
                          "when",
                          "around",
                          "deviceId"
                        ],
                        "handle": "connection",
                        "key": "History_supportHistoryConnection",
                        "kind": "LinkedHandle",
                        "name": "supportHistoryConnection"
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              (v9/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "80ddba2ecc666467dceb8e64bb8349b5",
    "id": null,
    "metadata": {},
    "name": "FreezeTransactionMutation",
    "operationKind": "mutation",
    "text": "mutation FreezeTransactionMutation(\n  $transferOrLedgerTransactionId: ID!\n  $note: String\n  $currentUserMobile: String\n  $canReadHistory: Boolean!\n  $canReadBalance: Boolean!\n  $amount: Decimal\n) {\n  freezeTransaction(transferOrLedgerTransactionId: $transferOrLedgerTransactionId, note: $note, currentUserMobile: $currentUserMobile, amount: $amount) {\n    success\n    user {\n      primaryWallet {\n        ...PersonalTabHeader_wallet_2fyIQr\n        ...History_wallet_4E6zJv @include(if: $canReadHistory)\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment AdjustmentEntry_tx on AdjustmentEntry {\n  __typename\n  description\n  senderMobile\n  recipientMobile\n  ...HistoryEntry_entry\n}\n\nfragment AgentDepositsBlockHistory_user on User {\n  id\n  historyOfAgentDepositsUnblocks {\n    whenBlocked\n    whenUnblocked\n    blockedBy\n    blockReason\n    blockSubject\n    unblockReason\n    unblockedBy\n  }\n}\n\nfragment AllowToRecoverPin_user on User {\n  id\n  inPinRecovery\n  isPinResetRisky\n  customerAppVersion {\n    appType\n    string\n    isUpToDate\n    appVersionCode\n  }\n}\n\nfragment BillPaymentEntry_tx on BillPaymentEntry {\n  transferId\n  senderMobile\n  maybeTerminatedSenderMobile\n  relatedTicket {\n    status\n    slackMessageUrl\n  }\n  scamReports {\n    whenOpened\n    whenResolved\n    status\n    transactionIds\n  }\n  billPayProblems {\n    whenOpened\n    billType\n    status\n    transactionId\n  }\n  amount\n  billAccount\n  billId\n  billName\n  isCancelled\n  summary\n  errorCode\n  localizedErrMessage\n  airtimeSms\n  meterNumber\n  ...HistoryEntry_entry\n}\n\nfragment BlockFromAgentDeposits_user on User {\n  id\n  agentDepositsBlock {\n    whenBlocked\n    blockedBy\n    blockReason\n    id\n  }\n  ...AgentDepositsBlockHistory_user\n}\n\nfragment BlockRecipient_transfer on MobileTransferEntry {\n  __isMobileTransferEntry: __typename\n  id\n  transferId\n  recipientName\n  recipientMobile\n}\n\nfragment BlockUnblockUser_wallet on Wallet {\n  id\n  mobile\n  activeMobileBlock {\n    id\n    blockReason\n    blockedBy\n    whenBlocked\n    blockSubject\n  }\n  activeLegalEntityBlock {\n    id\n    blockReason\n    blockedBy\n    whenBlocked\n    blockSubject\n  }\n  blockHistory {\n    whenBlocked\n    blockedBy\n    blockReason\n    whenUnblocked\n    unblockedBy\n    unblockReason\n    blockSubject\n  }\n}\n\nfragment CancelAllAtx_wallet on Wallet {\n  name\n  mobile\n}\n\nfragment ChangePayoutRecipient_transfer on PayoutTransferEntry {\n  tcid\n  amount\n  senderOpaqueId\n  sender: senderName\n  maybeRecipientName: recipientName\n  recipientMobile\n  isReversal\n}\n\nfragment ChangeRecipient_transfer on MobileTransferEntry {\n  __isMobileTransferEntry: __typename\n  id\n  transferId\n  amount\n  receiveAmount\n  recipientMobile\n  recipientName\n}\n\nfragment ChangeRemittanceRecipient_transfer on RemittanceTransferReceivedEntry {\n  opaqueId\n  senderName\n  senderMobile\n  amount\n}\n\nfragment ClearPinRateLimitAction_user on User {\n  devices {\n    hasPinRateLimitBlock\n  }\n  ...ClearPinRateLimit_user\n}\n\nfragment ClearPinRateLimit_user on User {\n  id\n  devices {\n    deviceId\n    deviceModel\n    deviceName\n    hasPinRateLimitBlock\n  }\n}\n\nfragment DirectDepositBlockHistory_user on User {\n  id\n  narrativeDirectDepositBlockHistory {\n    whatHappened\n    whenHappened\n    doneBy\n    reason\n  }\n}\n\nfragment EscalateToMerchantSupport_user on User {\n  possibleMerchantIssueTypes {\n    type\n    displayName\n  }\n  merchant {\n    ufid\n    id\n  }\n}\n\nfragment FailedMerchantTransferEntry_tx on FailedMerchantTransferEntry {\n  id\n  whenEntered\n  sendAmount\n  receiveAmount\n  isCancelled\n  merchantId\n  merchantName\n  scamInvestigationFields {\n    deviceId\n    deviceModel\n    deviceName\n    userInterface\n  }\n}\n\nfragment ForgetQr_user on User {\n  id\n  name\n  needsNewPin\n  primaryWallet {\n    name\n    id\n  }\n}\n\nfragment HistoryEntry_entry on HistoryEntry {\n  __isHistoryEntry: __typename\n  id\n  whenEntered\n  amount\n  balance\n  summary\n  isPending\n  isCancelled\n  ... on SupportHistoryEntry {\n    __isSupportHistoryEntry: __typename\n    scamInvestigationFields {\n      deviceId\n      deviceModel\n      deviceName\n      userInterface\n      agentMobile\n    }\n  }\n  ... on AgentTransactionEntry {\n    agentTransactionId\n  }\n  ... on TransferSentEntry {\n    transferId\n  }\n}\n\nfragment History_wallet_4E6zJv on Wallet {\n  mobile\n  cell: mobile\n  user {\n    devices {\n      deviceId\n      activeBlock {\n        blockReason\n        id\n      }\n    }\n    id\n  }\n  supportHistoryConnection(last: 10) {\n    edges {\n      cursor\n      node {\n        __typename\n        id\n        scamInvestigationFields {\n          deviceId\n          deviceModel\n          userInterface\n        }\n        ... on TransferSentEntry {\n          transferId\n          isPending\n          isCancelled\n        }\n        ... on TransferReceivedEntry {\n          transferId\n          isPending\n          isCancelled\n        }\n        ... on AgentTransactionEntry {\n          agentTransactionId\n          isPending\n          isCancelled\n        }\n        ... on BillPaymentEntry {\n          transferId\n          isPending\n          isCancelled\n        }\n        ... on PayoutTransferEntry {\n          tcid\n          isPending\n          isCancelled\n          amount\n        }\n        ...PersonalHistoryEntry_entry\n        ... on HistoryEntry {\n          __isHistoryEntry: __typename\n          whenEntered\n          isPending\n          isCancelled\n        }\n        ... on TransferReceivedReversalEntry {\n          reversedTransferId: transferId\n          isPending\n          isCancelled\n        }\n        ... on TransferSentReversalEntry {\n          reversedTransferId: transferId\n          isPending\n          isCancelled\n        }\n        ... on PurchaseEntry {\n          transferId\n          isPending\n          isCancelled\n        }\n        ... on RemittanceTransferReversalEntry {\n          opaqueId\n          isPending\n          isCancelled\n        }\n        ... on FailedMerchantTransferEntry {\n          sendAmount\n          receiveAmount\n          isCancelled\n        }\n      }\n    }\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n  }\n}\n\nfragment LoginLogoutEvent_tx on LoginLogoutEvent {\n  id\n  event\n  whenEntered\n  correspondingLoginTime\n  scamInvestigationFields {\n    deviceId\n    deviceModel\n    deviceName\n  }\n}\n\nfragment LogoutAllUserSessions_user on User {\n  id\n}\n\nfragment PaymentCardTransferEntry_tx on PaymentCardTransferEntry {\n  amount\n  summary\n  description\n  transferId\n  mobile\n  baseReceiptFields {\n    formatType\n    label\n    value\n  }\n  ...HistoryEntry_entry\n}\n\nfragment PayoutTransferEntry_tx on PayoutTransferEntry {\n  tcid\n  amount\n  senderOpaqueId\n  senderName\n  recipientMobile\n  isReversal\n  ...HistoryEntry_entry\n  ...SupportPayoutTransferReverse_transfer\n  ...ChangePayoutRecipient_transfer\n}\n\nfragment PersonalHistoryEntry_entry on SupportHistoryEntry {\n  __isSupportHistoryEntry: __typename\n  __typename\n  ...HistoryEntry_entry\n  ...UserAtxEntry_tx\n  ...BillPaymentEntry_tx\n  ...UserLinkedAccountTransferB2WEntry_tx\n  ...UserLinkedAccountTransferW2BEntry_tx\n  ...PaymentCardTransferEntry_tx\n  ...TransferReceivedEntry_tx\n  ...TransferSentEntry_tx\n  ...TransferSentReversalEntry_tx\n  ...TransferReceivedReversalEntry_tx\n  ...PayoutTransferEntry_tx\n  ...PurchaseEntry_tx\n  ...RemittanceTransferReceivedEntry_tx\n  ...RemittanceTransferReversalEntry_tx\n  ...AdjustmentEntry_tx\n  ...LoginLogoutEvent_tx\n  ...FailedMerchantTransferEntry_tx\n  ...ReversalDisputeEntry_tx\n}\n\nfragment PersonalTabHeader_wallet_2fyIQr on Wallet {\n  id\n  mobile\n  name\n  balance @include(if: $canReadBalance)\n  amountPending @include(if: $canReadBalance)\n  kycTier\n  kybTier\n  isTrader\n  photoEditUrl\n  documentStatus\n  hasRejectedGovIds\n  isRefundAbuser\n  whenTerminated\n  reasonTerminated\n  whoTerminated\n  tickets {\n    whenOpened\n    whenResolved\n    status\n    slackMessageUrl\n    ticketType\n    reference\n  }\n  activeMobileBlock {\n    whenBlocked\n    blockSubject\n    requestToModifyBlockTickets {\n      status\n    }\n    id\n  }\n  activeLegalEntityBlock {\n    whenBlocked\n    blockSubject\n    requestToModifyBlockTickets {\n      status\n    }\n    id\n  }\n  scamReports {\n    whenOpened\n    whenResolved\n    status\n    transactionIds\n  }\n  billPayProblems {\n    whenOpened\n    billType\n    status\n    transactionId\n  }\n  supportGroupLeadEscalations {\n    whenOpened\n    status\n    clickupTaskId\n  }\n  supportPartialRefundEscalations {\n    whenOpened\n    status\n    clickupTaskId\n  }\n  merchantSupportEscalations {\n    whenOpened\n    status\n    clickupTaskId\n  }\n  balanceLimitInfoV1 {\n    max\n  }\n  inflowLimitInfoV1 {\n    max\n  }\n  ...ShowWithdrawalCodes_wallet\n  ...ShowWoyofalCodes_wallet\n  ...ResetPin_wallet\n  ...SendUpdateAppLink_wallet\n  ...SendWithdrawalCode_wallet\n  ...SendWoyofalCode_wallet\n  ...RenameWallet_wallet\n  ...CancelAllAtx_wallet\n  ...RequestToBlockUnblockUser_wallet\n  ...RequestToUnblockFromAgentDeposits_wallet\n  ...RequestToUnblockFromUsingMultipleDevices_wallet\n  ...BlockUnblockUser_wallet\n  user {\n    isPinResetRisky\n    devices {\n      deviceId\n      deviceModel\n      whenLoggedOut\n      failedLoginDevice\n      activeBlock {\n        blockReason\n        id\n      }\n    }\n    customerAppVersion {\n      appType\n      string\n      isUpToDate\n    }\n    hasQrCard\n    customerOverdraftStatus\n    qrCardBlock {\n      whenBlocked\n      id\n    }\n    personalMultipleDevicesBlock {\n      whenBlocked\n      id\n    }\n    agentMultipleDevicesBlock {\n      whenBlocked\n      id\n    }\n    agentDepositsBlock {\n      whenBlocked\n      id\n    }\n    needsIdPhotoConfirmation {\n      legalName\n    }\n    userOnAgentGamingWatchlist {\n      isOnList\n      whenUpdated\n    }\n    userOnAgentGamingWhitelist {\n      isOnList\n      whenUpdated\n    }\n    inPinRecovery\n    hasWeakPin\n    elligibleToReceivePayPromo\n    ...AllowToRecoverPin_user\n    ...UnblockFromUsingQrCards_user\n    ...UnblockFromUsingMultipleDevices_user\n    ...BlockFromAgentDeposits_user\n    ...UnblockFromAgentDeposits_user\n    ...LogoutAllUserSessions_user\n    ...ForgetQr_user\n    ...EscalateToMerchantSupport_user\n    ...ClearPinRateLimitAction_user\n    id\n  }\n  legalEntity {\n    wallets(walletType: PERSONAL) {\n      mobile\n      id\n    }\n  }\n}\n\nfragment PurchaseEntry_tx on PurchaseEntry {\n  senderMobile\n  maybeTerminatedSenderMobile\n  amount\n  merchantId\n  merchantName\n  merchantCode\n  merchantMobile\n  promoUsed\n  transferId\n  isRefunded\n  isRemote\n  relatedTicket {\n    whenOpened\n    whenResolved\n    status\n    slackMessageUrl\n    ticketType\n    reference\n  }\n  scamReports {\n    whenOpened\n    whenResolved\n    status\n    transactionIds\n  }\n  ...HistoryEntry_entry\n  ...RefundPurchaseEntry_transfer\n}\n\nfragment RefundP2P_transfer on MobileTransferEntry {\n  __isMobileTransferEntry: __typename\n  id\n  transferId\n  sendAmount\n  receiveAmount\n  senderName\n  senderMobile\n  recipientName\n  maybeTerminatedRecipientMobile\n}\n\nfragment RefundPurchaseEntry_transfer on PurchaseEntry {\n  id\n  transferId\n  amount\n  merchantName\n}\n\nfragment RemittanceTransferReceivedEntry_tx on RemittanceTransferReceivedEntry {\n  id\n  opaqueId\n  description\n  amount\n  isPending\n  isCancelled\n  senderName\n  senderMobile\n  senderCountry\n  recipientMobile\n  receiveAmount\n  ...HistoryEntry_entry\n  ...RemittanceTransferRefund_transfer\n  ...ChangeRemittanceRecipient_transfer\n}\n\nfragment RemittanceTransferRefund_transfer on RemittanceTransferReceivedEntry {\n  opaqueId\n  senderName\n  senderMobile\n  amount\n}\n\nfragment RemittanceTransferReversalEntry_tx on RemittanceTransferReversalEntry {\n  id\n  opaqueId\n  description\n  amount\n  isPending\n  senderName\n  senderMobile\n  senderCountry\n  recipientMobile\n  receiveAmount\n  ...HistoryEntry_entry\n}\n\nfragment RenameWallet_wallet on Wallet {\n  id\n  name\n  mobile\n  user {\n    name\n    id\n  }\n}\n\nfragment RequestToBlockUnblockUser_wallet on Wallet {\n  id\n  mobile\n  activeMobileBlock {\n    whenBlocked\n    id\n  }\n  activeLegalEntityBlock {\n    whenBlocked\n    id\n  }\n  blockHistory {\n    whenBlocked\n    blockedBy\n    blockReason\n    whenUnblocked\n    unblockedBy\n    unblockReason\n    blockSubject\n  }\n  tickets {\n    whenOpened\n    whenResolved\n    status\n    slackMessageUrl\n    ticketType\n    reference\n  }\n}\n\nfragment RequestToUnblockFromAgentDeposits_wallet on Wallet {\n  id\n  mobile\n  activeMobileBlock {\n    whenBlocked\n    id\n  }\n  activeLegalEntityBlock {\n    whenBlocked\n    id\n  }\n  blockHistory {\n    whenBlocked\n    blockedBy\n    blockReason\n    whenUnblocked\n    unblockedBy\n    unblockReason\n    blockSubject\n  }\n  tickets {\n    whenOpened\n    whenResolved\n    status\n    slackMessageUrl\n    ticketType\n    reference\n  }\n}\n\nfragment RequestToUnblockFromUsingMultipleDevices_wallet on Wallet {\n  id\n  mobile\n  activeMobileBlock {\n    whenBlocked\n    id\n  }\n  activeLegalEntityBlock {\n    whenBlocked\n    id\n  }\n  blockHistory {\n    whenBlocked\n    blockedBy\n    blockReason\n    whenUnblocked\n    unblockedBy\n    unblockReason\n    blockSubject\n  }\n  tickets {\n    whenOpened\n    whenResolved\n    status\n    slackMessageUrl\n    ticketType\n    reference\n  }\n}\n\nfragment ResetPin_wallet on Wallet {\n  name\n  user {\n    id\n    isPinResetRisky\n  }\n}\n\nfragment ReversalDisputeEntry_tx on ReversalDisputeEntry {\n  __typename\n  description\n  isPending\n  ledgerTransactionId\n  originalTransferId\n  ...HistoryEntry_entry\n}\n\nfragment SendUpdateAppLink_wallet on Wallet {\n  mobile\n  name\n  id\n}\n\nfragment SendWithdrawalCode_wallet on Wallet {\n  id\n  mobile\n  name\n}\n\nfragment SendWoyofalCode_wallet on Wallet {\n  id\n  mobile\n  name\n}\n\nfragment ShowWithdrawalCodes_wallet on Wallet {\n  id\n  name\n  mobile\n  ...SendWithdrawalCode_wallet\n}\n\nfragment ShowWoyofalCodes_wallet on Wallet {\n  id\n  name\n  mobile\n  ...SendWoyofalCode_wallet\n}\n\nfragment SupportPayoutTransferReverse_transfer on PayoutTransferEntry {\n  tcid\n  amount\n  senderOpaqueId\n  sender: senderName\n  maybeRecipientName: recipientName\n  recipientMobile\n  isReversal\n}\n\nfragment TransferReceivedEntry_tx on TransferReceivedEntry {\n  transferId\n  senderName\n  senderMobile\n  maybeTerminatedSenderMobile\n  paymentBatchId\n  recipientMobile\n  receiveAmount\n  ...HistoryEntry_entry\n  ...ChangeRecipient_transfer\n  ...RefundP2P_transfer\n}\n\nfragment TransferReceivedReversalEntry_tx on TransferReceivedReversalEntry {\n  transferId\n  description\n  isPending\n  isFreezingFunds\n  ledgerTransactionId\n  senderMobile\n  sendAmount\n  recipientMobile\n  ...HistoryEntry_entry\n}\n\nfragment TransferSentEntry_tx on TransferSentEntry {\n  transferId\n  senderMobile\n  recipientName\n  recipientMobile\n  maybeTerminatedRecipientMobile\n  amount\n  receiveAmount\n  relatedTicket {\n    whenOpened\n    whenResolved\n    status\n    slackMessageUrl\n    ticketType\n    reference\n  }\n  scamReports {\n    whenOpened\n    whenResolved\n    status\n    transactionIds\n  }\n  ...ChangeRecipient_transfer\n  ...RefundP2P_transfer\n  ...BlockRecipient_transfer\n  ...HistoryEntry_entry\n}\n\nfragment TransferSentReversalEntry_tx on TransferSentReversalEntry {\n  transferId\n  description\n  isPending\n  isFreezingFunds\n  ledgerTransactionId\n  senderMobile\n  sendAmount\n  ...HistoryEntry_entry\n}\n\nfragment UnblockFromAgentDeposits_user on User {\n  id\n  agentDepositsBlock {\n    whenBlocked\n    blockedBy\n    blockReason\n    id\n  }\n  ...AgentDepositsBlockHistory_user\n}\n\nfragment UnblockFromUsingMultipleDevices_user on User {\n  id\n  personalMultipleDevicesBlock {\n    blockReason\n    blockedBy\n    whenBlocked\n    whenExpires\n    lockedDevice {\n      deviceId\n      deviceName\n      deviceModel\n    }\n    id\n  }\n  agentMultipleDevicesBlock {\n    blockReason\n    blockedBy\n    whenBlocked\n    whenExpires\n    lockedDevice {\n      deviceId\n      deviceName\n      deviceModel\n    }\n    id\n  }\n  ...DirectDepositBlockHistory_user\n}\n\nfragment UnblockFromUsingQrCards_user on User {\n  ...DirectDepositBlockHistory_user\n  id\n  qrCardBlock {\n    whenBlocked\n    blockedBy\n    blockReason\n    whenExpires\n    id\n  }\n}\n\nfragment UserAtxEntry_tx on AgentTransactionEntry {\n  agentTransactionId\n  isDeposit\n  agentName\n  agentId\n  agentUfid\n  customerMobile\n  customerName\n  maybeTerminatedCustomerMobile\n  amount\n  relatedTicket {\n    whenOpened\n    whenResolved\n    status\n    slackMessageUrl\n    ticketType\n    reference\n  }\n  scamReports {\n    whenOpened\n    whenResolved\n    status\n    transactionIds\n  }\n  ...HistoryEntry_entry\n}\n\nfragment UserLinkedAccountTransferB2WEntry_tx on UserLinkedAccountTransferB2WEntry {\n  summary\n  isCancelled\n  partnerName\n  liaTransferId\n  errorCode\n  errorMessage\n  ...HistoryEntry_entry\n}\n\nfragment UserLinkedAccountTransferW2BEntry_tx on UserLinkedAccountTransferW2BEntry {\n  summary\n  isCancelled\n  partnerName\n  liaTransferId\n  errorCode\n  errorMessage\n  ...HistoryEntry_entry\n}\n"
  }
};
})();
(node as any).hash = 'b65c6324bfeef7f5a6cf837b4e8ef2a2';
export default node;
